import { Navigate } from 'react-router-dom';
import { ReactNode } from 'react';
import { useAuth } from 'src/contexts/AuthContext';

type Props = {
  children: ReactNode;
};

export default function AuthGuard({ children }: Props) {
  const { isAuthenticated, isLoading } = useAuth();

  if (isLoading) {
    return null;
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  return <>{children}</>;
}
